/* eslint-disable import/no-deprecated */
import React from 'react';
import { TextInput } from '../../components/TextInput';
import { Icon } from '../../deprecated/Icon';
import { identifyComponent } from '../../util';
import { Box } from '../Box';

export interface SelectMenuFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  compact?: boolean;
}

export const SelectMenuFilter = React.forwardRef<HTMLInputElement, SelectMenuFilterProps>(
  ({ value, onChange, placeholder, compact }, ref) => (
    <TextInput
      data-component="SelectMenuFilter"
      size={compact ? 'small' : 'medium'}
      variant="minimal"
      ref={ref}
      value={value}
      onChange={e => onChange(e.target.value)}
      leftAdornment={
        <Box marginLeft={12}>
          <Icon
            name="search"
            color="pink-base"
            size={16}
            grammarUIPropOverrides={{ color: 'base-objects-default' }}
          />
        </Box>
      }
      placeholder={placeholder}
      {...identifyComponent('select-menu-filter')}
    />
  ),
);

SelectMenuFilter.displayName = 'SelectMenuFilter';
